import Slick from 'vue-slick';
//import 'slick-carousel/slick/slick.scss';

import template from './slot-input-slider.vhtml';

export default {
	components: {
		Slick,
	},
	template,
	props: {
		sliderItems: {
			'type': Array,
			'default': null,
		},
		perPage: {
			'type': Number,
			'default': 1,
		},
		dotsClass: {
			type: String,
			default: 'slider__dots',
		}
	},
	data() {
		return {
			currentItem: null,
			items: [],
			location: 0,
			counter: 1,
			navigatedRight: false,
			slickOptions: {
				centerMode: true,
				slidesToShow: this.perPage,
				slidesToScroll: this.perPage,
				arrows: false,
				dots: true,
				dotsClass: this.dotsClass,
				easing: 'cubic-bezier( .395, .325, .365, .995 )',
				centerPadding: '15%',
				responsive: [
					{
						breakpoint: 2000,
						settings: {
							centerPadding: '8%',
						}
					},
					{
						breakpoint: 600,
						settings: {
							centerPadding: '14px',
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					},
				]
			},
		}
	},
	methods: {
		next() {
			this.page += 1;
			this.$refs.slick.next();
			this.selectSlides();			
		},
		prev() {
			this.page -= 1;
			this.$refs.slick.prev();
			this.selectSlides();
		},
		selectSlides() {
			$( '.is-active', this.$el ).removeClass( 'is-active' );
			$( '[data-slick-index=' + this.$refs.slick.currentSlide() + ']', this.$el ).prev().addBack().addClass( 'is-active' );
		},
		swipe(e, slick, direction) {
			$('.is-active', this.$el).removeClass('is-active');
			$('[data-slick-index=' + this.$refs.slick.currentSlide() + ']', this.$el).prev().addBack().addClass('is-active');
		},
	},
	mounted() {
		this.items = this.sliderItems;
		$('[data-slick-index=' + this.$refs.slick.currentSlide() + ']', this.$el).prev().addBack().addClass('is-active');
	},
}


// WEBPACK FOOTER //
// ./assets/_js/components/slot-input-slider/slot-input-slider.js